import React from "react";
import PropTypes from "prop-types";
import "./ActionGroup.scss";

import Button from "../Button/Button";
import copyIcon from "./images/copy.svg";
import cpcIcon from "./images/cpc.svg";
import deleteIcon from "./images/delete.svg";
import stopIcon from "./images/stop.svg";
import startIcon from "./images/start.svg";

const ActionGroup = ({
  onClick,
  cnt,
  onStopClick,
  onStartClick,
  onCopyClick,
  onCpcClick,
  onDeleteClick
}) => (
  <div className="action-group">
    <div className="action-group__selection">
      Выбрано: <span className="action-group__cnt">{cnt}</span> анонсов
    </div>

    <div className="action-group__buttons">
      <Button icon={startIcon} color="light-green" onClick={onStartClick} />
      <Button icon={stopIcon} color="light-green" onClick={onStopClick} />
      <Button icon={copyIcon} color="light-green" onClick={onCopyClick} />
      {/*<Button icon={cpcIcon} color="light-green" onClick={onCpcClick} />*/}
      <Button icon={deleteIcon} color="light-green" onClick={onDeleteClick} />
    </div>
  </div>
);

ActionGroup.propTypes = {
  cnt: PropTypes.number,
  onStopClick: PropTypes.func.isRequired,
  onStartClick: PropTypes.func.isRequired,
  onCopyClick: PropTypes.func.isRequired,
  onCpcClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired
};

export default ActionGroup;
